exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal{display:none;position:fixed;top:0;left:0;width:100%;height:100%;overflow:auto;background-color:#000;background-color:rgba(0,0,0,.4);z-index:1050;padding-top:60px}.modal-dialog{margin:auto;width:80%;max-width:600px}.modal-content{position:relative;background-color:#fff;border:1px solid #888;border-radius:.3rem;box-shadow:0 3px 9px rgba(0,0,0,.5);outline:0}", ""]);

// exports
